import React, { useContext } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'

import Col from 'components/Col'
import Row from 'components/Row'
import Container from 'components/Container'
import {
  LOGIN_PATH,
  FORGOT_PASSWORD_PATH,
  CHANGE_PASSWORD_PATH,
  REGISTRATION_PATH,
  LEGAL_TERM_PATH,
  COOKIE_SETTINGS_PATH
} from 'routing/constants'

import LogoImage from 'assets/kba-logo'
import { ExistingUserLoginLink, StyledLoginButton, StyledLangButton, TopBarUnAuthorizedWrapper } from './style'
import { IntlContext } from 'providers/intl'

const pagesWithWhiteColoredHeader = [LOGIN_PATH, FORGOT_PASSWORD_PATH, CHANGE_PASSWORD_PATH]

const UnAuthorizedHeader = () => {
  const location = useLocation()
  const { setLang, lang } = useContext(IntlContext)
  const isLegalTerm = LEGAL_TERM_PATH === location.pathname
  const cookieSettings = COOKIE_SETTINGS_PATH === location.pathname
  const isWhiteColoredHeader = pagesWithWhiteColoredHeader.includes(location.pathname)

  const handleChange = (event) => {
    setLang(event.target.value)
  }

  return (
    <div style={{ width: '100%', zIndex: '10', position: `${isWhiteColoredHeader ? 'fixed' : ''}` }}>
      <Container
        width={isWhiteColoredHeader ? '100%' : isLegalTerm ? '100%' : '1440px'}
        position={isLegalTerm ? 'fixed' : ''}
        background={isLegalTerm ? '#FFF' : ''}
      >
        <Row>
          <Col xs={12}>
            <TopBarUnAuthorizedWrapper isWhiteColoredHeader={isWhiteColoredHeader}>
              <LogoImage />
              {isLegalTerm && (
                <div style={{ fontSize: '20px', lineHeight: '32px', fontWeight: '600' }}>
                  <FormattedMessage id="localTerms" />
                </div>
              )}
              {cookieSettings && (
                <div style={{ fontSize: '20px', lineHeight: '32px', fontWeight: '600' }}>
                  <FormattedMessage id="cookieSettings" />
                </div>
              )}
              {location.pathname !== CHANGE_PASSWORD_PATH && !isLegalTerm && !cookieSettings && (
                <ExistingUserLoginLink data-test="sign-up-in">
                  <div style={{ color: isWhiteColoredHeader ? 'rgba(32, 32, 32, 0.7)' : '#202020' }}>
                    <FormattedMessage id={isWhiteColoredHeader ? 'dontHaveAnAccount' : 'alreadyHaveAnAccount?'} />
                  </div>
                  <StyledLoginButton
                    color={isWhiteColoredHeader ? '#fff' : null}
                    border={isWhiteColoredHeader ? 'none' : null}
                    background={isWhiteColoredHeader ? '#0AA1F4' : null}
                  >
                    <Link
                      style={{ textDecoration: 'none', color: isWhiteColoredHeader ? '#fff' : '#0AA1F4' }}
                      exact
                      strict
                      to={isWhiteColoredHeader ? REGISTRATION_PATH : LOGIN_PATH}
                    >
                      <FormattedMessage id={isWhiteColoredHeader ? 'Register' : 'signIn'} />
                    </Link>
                  </StyledLoginButton>
                  <StyledLangButton>
                    <div className="lang-options">
                      <select
                        style={{ textDecoration: 'none', color: '#000', background: '#FFF', borderRadius: '7px' }}
                        className="lang-optionsBtn"
                        onChange={handleChange}
                        defaultValue={lang}
                      >
                        {['English', 'Spanish', 'French'].map((x) => {
                          return (
                            <option key={x} value={x}>
                              {x}
                            </option>
                          )
                        })}
                      </select>
                    </div>
                  </StyledLangButton>
                </ExistingUserLoginLink>
              )}
              {(isLegalTerm || cookieSettings) && (
                <div>
                  <Link
                    style={{ textDecoration: 'none', color: '#0AA1F4', marginRight: '32px' }}
                    exact
                    strict
                    to={LOGIN_PATH}
                  >
                    <FormattedMessage id="signIn" />
                  </Link>
                  <Link
                    style={{
                      textDecoration: 'none',
                      color: '#FFF',
                      background: '#0AA1F4',
                      borderRadius: '4px',
                      boxShadow: 'rgba(32, 32, 32, 0.05)',
                      padding: '12px 24px 12px 24px'
                    }}
                    exact
                    strict
                    to={REGISTRATION_PATH}
                  >
                    <FormattedMessage id="signUp" />
                  </Link>
                </div>
              )}
            </TopBarUnAuthorizedWrapper>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default UnAuthorizedHeader
